import $ from "jquery";

$(window).scroll((event) => {
  if ($(event.currentTarget).scrollTop() > 100) {
    $('#js-header').addClass('-change');
    $('#js-headerLogo').addClass('-change');
    $('#js-hamburger').addClass('-change');
    $('#js-hamburgerInner').addClass('-change');
  } else {
    $('#js-header').removeClass('-change');
    $('#js-headerLogo').removeClass('-change');
    $('#js-hamburger').removeClass('-change');
    $('#js-hamburgerInner').removeClass('-change');
  }
});
